import { fromAsset, isAsset } from '../../lib/asset';
import { useOptions } from '@topwrite/common';
import { forwardRef, ImgHTMLAttributes, memo, useEffect, useState } from 'react';
import { socket } from '../../lib/socket';
import LocalImage from '../local-image';
import useFilename from '../../lib/use-filename';

const Img = memo(forwardRef<HTMLImageElement, ImgHTMLAttributes<HTMLImageElement>>(function({ src, ...props }, ref) {

    const filename = useFilename(src);

    if (filename) {
        if (isAsset(filename)) {
            return <AssetImg ref={ref} filename={filename} {...props} />;
        } else {
            return <LocalImage ref={ref} src={filename} {...props} autoReload />;
        }
    }

    return <img ref={ref} src={src} {...props} />;
}));

export default Img;

const AssetImg = forwardRef<HTMLImageElement, ImgHTMLAttributes<HTMLImageElement> & {
    filename: string
}>(function({ filename, ...props }, ref) {
    const { asset } = useOptions();
    const [time, setTime] = useState<number>();
    let src = asset + fromAsset(filename);
    if (time) {
        src += '?t=' + time;
    }

    useEffect(() => {
        const listener = function(names: string[]) {
            if (names.includes(filename)) {
                setTime(new Date().getTime());
            }
        };

        socket.on('file.change', listener);

        return () => {
            socket.off('file.change', listener);
        };
    }, [filename]);

    return <img ref={ref} src={src} {...props} />;
});
